import { ClipLoader } from 'react-spinners'
import { useTheme } from '@itsrever/design-system'
import { useAppSelector } from '@/redux/hooks'

export interface LoadingProps {
    loading: boolean
    size?: string
}

export const Loading: React.FC<LoadingProps> = ({ loading, size }) => {
    const theme = useTheme()
    const settings = useAppSelector(
        (store) => store.settingsApi.settings.response
    )
    const isHoff = settings.ecommerce_group === 'hoff'

    const spinnerColor = theme?.colors?.primary.main

    if (isHoff) {
        return <></>
    }

    return (
        <div className="flex size-full items-center justify-center p-4">
            <ClipLoader
                color={spinnerColor}
                loading={loading}
                size={size || '125px'}
            />
        </div>
    )
}

export default Loading
